// Logo de CaptAcción optimizado (WebP sin márgenes, 1x/2x). Original: public/logo-captaccion.png.
const SIZES = {
  sm: "h-7",
  md: "h-9",
  lg: "h-12",
  xl: "h-16",
  "2xl": "h-24",
  "3xl": "h-28 sm:h-36",
};

// Full brand logo (the CAPTACCIÓN wordmark) on a transparent background.
export function LogoImage({ size = "md", className = "" }) {
  const h = SIZES[size] || SIZES.md;
  return <img src="/logo-captaccion-h96.webp" srcSet="/logo-captaccion-h96.webp 1x, /logo-captaccion-h192.webp 2x" alt="CaptAcción" className={`${h} w-auto max-w-full object-contain object-left ${className}`} />;
}

// Alias kept for existing imports.
export function Mark({ size = "h-9", className = "" }) {
  return <img src="/logo-captaccion-h96.webp" srcSet="/logo-captaccion-h96.webp 1x, /logo-captaccion-h192.webp 2x" alt="CaptAcción" className={`${size} w-auto max-w-full object-contain object-left ${className}`} />;
}

// Text fallback (unused in UI now that the real logo is available).
export function Wordmark({ className = "", size = "text-lg", dark = false }) {
  const base = dark ? "text-white" : "text-brand-ink";
  return (
    <span className={`font-extrabold tracking-tight ${size} ${base} ${className}`} style={{ letterSpacing: "-0.02em" }}>
      CAPT<span style={{ color: "#D8B45E" }}>A</span>CCIÓN
    </span>
  );
}
